import { Component, Input } from 'angular2/core';
import { CORE_DIRECTIVES } from 'angular2/common';
import { Subscription } from 'rxjs';
import { SortService, ISortSettingInstance } from './sort-service';

@Component({
	selector: 'sort',
	template: `	<i *ngIf="isDesc()" (click)="changeOrder()" class="material-icons" style="cursor:pointer;">keyboard_arrow_down</i>
				<i *ngIf="isAsc()" (click)="changeOrder()" class="material-icons" style="cursor:pointer;">keyboard_arrow_up</i>
				<i *ngIf="isNull()" (click)="changeOrder()" class="material-icons" style="cursor:pointer;">remove</i>`,
	directives: [CORE_DIRECTIVES]
})
export class SortCmp {
	@Input() table: string;
	@Input() field: string;
	@Input() type: string;
	@Input() default: string;

	private order: string = 'desc';
	private instance: ISortSettingInstance;

	constructor(private service: SortService) {

	}

	public changeOrder() {
		switch (this.instance.order) {
			case 'asc':
				this.instance.order = 'desc';
				break;
			case 'desc':
				this.instance.order = 'null';
				break;
			case 'null':
				this.instance.order = 'asc';
				break;
		}
		this.service.save(this.instance);
	}

	public isDesc() {
		return this.instance.order === 'desc';
	}

	public isAsc() {
		return this.instance.order === 'asc';
	}

	public isNull() {
		return this.instance.order === 'null';
	}

	private ngOnInit() {
		this.instance = {
			table: this.table,
			field: this.field,
			type: this.type,
			order: this.default
		};
		if (this.default && this.default !== 'null') {
			this.instance.order = this.default;
			this.service.save(this.instance);
		} else {
			this.instance.order = 'null';
		}
	}

}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./src/sort/sort.ts
 **/